module.exports = __webpack_public_path__ + "static/media/empty-state-metrics.c34d7e20.svg";